module.exports = __webpack_public_path__ + "static/img/Carte.e953ca4.png";


//////////////////
// WEBPACK FOOTER
// ./src-detail/img/Carte.png
// module id = DB3q
// module chunks = 1